// extracted by mini-css-extract-plugin
export default {"font_family_select":"FontFamilySelect_font_family_select__32TMB"};